import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllCreditsCommand } from '@/app/credit/commands/get-all-credits.command'

const httpClient = new AxiosClient()

export const getAllCreditsCommand = new GetAllCreditsCommand(httpClient, store)
